export const somenteNumeros = (value) => {
    if (!value) return null;
    return value.toString()
        .replace(/\D/g, '');
};

export const formatarData = (value) => {
    if (!value) return null;
    const valorFormatadoDataBrasileira = value.substr(0, 10).split('-').reverse().join('/');
    return valorFormatadoDataBrasileira
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\d{2})(\d)/, '$1/$2')
        .replace(/(\/\d{4})\d+?$/, '$1');
};

export const formatarDataHora = (value) => {
    if (!value) return null;

    const ano = value.substring(0, 4)
    const mes = value.substring(5, 7)
    const dia = value.substring(8, 10)
    const hora = value.substring(11, 13)
    const minuto = value.substring(14, 16)
    const segundos = value.substring(17, 19)

    const novaData = new Date(Date.UTC(ano, (mes-1), dia, hora, minuto, segundos));
    return novaData.toLocaleString('pt-BR', { timezone: 'UTC' })
};

export const formatarDataHoraLocaleString = (value) => {
  if (!value) return null;
  return new Date(value).toLocaleString('pt-BR', { timezone: 'UTC' })
};

export const formatarCNPJ = (entry) => {
    const cnpj = [];
    if (entry) {
        if (
            typeof (entry) !== 'number'
            && entry.search(/[^0-9]/g) > -1
        ) return;
        if (typeof (entry) !== 'string') entry = entry.toString();
        if (entry.indexOf(/\D/g) > -1) return;
        if (entry.length === 11) return formatarCPF(entry);
        if (entry.length === 14) {
            cnpj[0] = entry.substr(0, 2);
            cnpj[1] = entry.substr(2, 3);
            cnpj[2] = entry.substr(5, 3);
            cnpj[3] = entry.substr(8, 4);
            cnpj[4] = entry.substr(12, 2);
        }
    }
    return (cnpj.length > 0
            ? `${cnpj[0]}.${cnpj[1]}.${cnpj[2]}/${cnpj[3]}-${cnpj[4]}`
            : false
    );
};
export const formatarCPF = (entry) => {
    const cpf = [];
    if (entry) {
        if (
            typeof (entry) !== 'number'
            && entry.search(/[^0-9]/g) > -1
        ) return;
        if (typeof (entry) !== 'string') entry = entry.toString();
        if (entry.indexOf(/\D/g) > -1) return;
        if (entry.length === 14) return formatarCNPJ(entry);
        if (entry.length === 11) {
            cpf[0] = entry.substr(0, 3);
            cpf[1] = entry.substr(3, 3);
            cpf[2] = entry.substr(6, 3);
            cpf[3] = entry.substr(9, 2);
        }
    }
    return (cpf.length > 0 ? `${cpf[0]}.${cpf[1]}.${cpf[2]}-${cpf[3]}` : false);
};

export const formatarDinheiroParaDecimal = (valor) => {
    if (!valor) return;
    valor =  valor.replaceAll(".", "").replaceAll(",", "")
    valor = valor.substring(0, valor.length-2)+"."+valor.substring(valor.length -2,valor.length);
    return valor
}
export const formatarPorcentagemParaDecimal = (valor) => {
    if (!valor) return;
    valor =  valor.replaceAll(".", "").replaceAll(",", "")
    valor = valor.substring(0, valor.length-2)+"."+valor.substring(valor.length -2,valor.length);
    return valor
}

export const formatarPorcentagem = (valor) => {
    valor = somenteNumeros(valor);
    if (!valor) return ''
    let v = String(valor).replace(/\D/g, '');
    v = (v/100).toFixed(2);
    v = v.replace(".", ",");
    return v;
}

export const formatarDinheiro = (valor) => {
    valor = somenteNumeros(valor);
    if (!valor) return ''
    let v = String(valor).replace(/\D/g, '');
    v = (v/100).toFixed(2);
    v = v.replace(".", ",");
    v = v.replace(/(\d)(\d{3})(\d{3})(\d{3})(\d{3}),/g, "$1.$2.$3.$4.$5,");
    v = v.replace(/(\d)(\d{3})(\d{3})(\d{3}),/g, "$1.$2.$3.$4,");
    v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
    v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
    return v;

};

export const formatarDinheiroItl = (valor) => {
    const REAL = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });
    return REAL.format(valor)
}

export function formatarTelefone(telefone){
  const t = somenteNumeros(telefone)
  if (!t) return ''
  if (t.length > 0 && t.length < 3) return t
  if (t.length >= 3 && t.length <= 7) return `(${t.substring(0,2)}) ${t.substring(2, 7)}`
  return `(${t.substring(0,2)}) ${t.substring(2, 7)}-${t.substring(7, 11)}`
}

export const formatarDataLocalDate = (value) => {
    const ano = value.substring(0, 4)
    const mes = value.substring(5, 7)
    const dia = value.substring(8, 10)
    return dia+"/"+mes+"/"+ano
}
